/**
 * Wave 25 — Country SEO i18n
 * New: Togo 🇹🇬
 * Gap-fill: Estonia 🇪🇪, Paraguay 🇵🇾 (missing ZH/JA/KO/SV/DA)
 */
import type { CountrySEOMap } from './country-seo-i18n-types';

export const COUNTRY_SEO_I18N_WAVE25: CountrySEOMap = {

  togo: {
    fr: {
      title: 'Centre d\'appel Togo | Service Client Francophone | Call IT Dev',
      description: 'Externalisez votre centre d\'appel au Togo : agents francophones natifs, fuseau GMT, CSAT 95%, dès 3 $/h. 80% d\'économies. Hub Afrique de l\'Ouest.',
      heroTitle: 'Centre d\'appel pour le Togo — Support francophone depuis Casablanca',
      heroSubtitle: 'Service client premium en français pour le marché togolais. Fuseau GMT, 80% moins cher.',
    },
    es: {
      title: 'Call Center Togo | Atención al Cliente Francófona | Call IT Dev',
      description: 'Call center para Togo: agentes francófonos nativos, zona GMT, CSAT 95%, desde 3 $/h. 80% ahorro.',
      heroTitle: 'Call Center para Togo — Soporte Francófono desde Casablanca',
      heroSubtitle: 'Atención al cliente premium para el mercado togolés. Zona GMT, 80% más barato.',
    },
    de: {
      title: 'Call Center Togo | Französischsprachiger Kundenservice | Call IT Dev',
      description: 'Call Center für Togo: französischsprachige Agenten, GMT-Zeitzone, CSAT 95%, ab 3 $/h. 80% Ersparnis.',
      heroTitle: 'Call Center für Togo — Französischsprachiger Support',
      heroSubtitle: 'Premium-Kundenservice für den togolesischen Markt. GMT-Zeitzone, 80% günstiger.',
    },
    ar: {
      title: 'مركز اتصال توغو | خدمة عملاء بالفرنسية | Call IT Dev',
      description: 'مركز اتصال لتوغو: وكلاء فرنكوفونيون أصليون، منطقة GMT، CSAT 95%، من 3 $/ساعة. توفير 80%.',
      heroTitle: 'مركز اتصال لتوغو — دعم فرنكوفوني من الدار البيضاء',
      heroSubtitle: 'خدمة عملاء متميزة للسوق التوغولي. منطقة GMT، أقل 80%.',
    },
    it: {
      title: 'Call Center Togo | Assistenza Clienti Francofona | Call IT Dev',
      description: 'Call center per il Togo: agenti francofoni, fuso GMT, CSAT 95%, da 3 $/h. 80% risparmio.',
      heroTitle: 'Call Center per il Togo — Supporto Francofono da Casablanca',
      heroSubtitle: 'Assistenza clienti premium per il mercato togolese. Fuso GMT, 80% in meno.',
    },
    pt: {
      title: 'Call Center Togo | Atendimento Francófono | Call IT Dev',
      description: 'Call center para Togo: agentes francófonos, fuso GMT, CSAT 95%, a partir de 3 $/h. 80% economia.',
      heroTitle: 'Call Center para Togo — Suporte Francófono de Casablanca',
      heroSubtitle: 'Atendimento premium para o mercado togolês. Fuso GMT, 80% mais barato.',
    },
    nl: {
      title: 'Callcenter Togo | Franstalige Klantenservice | Call IT Dev',
      description: 'Callcenter voor Togo: Franstalige agenten, GMT-tijdzone, CSAT 95%, vanaf 3 $/u. 80% besparing.',
      heroTitle: 'Callcenter voor Togo — Franstalige Support vanuit Casablanca',
      heroSubtitle: 'Premium klantenservice voor de Togolese markt. GMT-tijdzone, 80% goedkoper.',
    },
    pl: {
      title: 'Call Center Togo | Frankofoniczna Obsługa Klienta | Call IT Dev',
      description: 'Call center dla Togo: frankofonowie, strefa GMT, CSAT 95%, od 3 $/h. 80% oszczędności.',
      heroTitle: 'Call Center dla Togo — Frankofońskie Wsparcie z Casablanki',
      heroSubtitle: 'Premiumowa obsługa klienta dla rynku togolskiego. Strefa GMT, 80% taniej.',
    },
    tr: {
      title: 'Togo Çağrı Merkezi | Fransızca Müşteri Hizmetleri | Call IT Dev',
      description: 'Togo için çağrı merkezi: Fransızca konuşanlar, GMT saat dilimi, CSAT %95, 3 $/saatten başlayan.',
      heroTitle: 'Togo İçin Çağrı Merkezi — Kazablanka\'dan Fransızca Destek',
      heroSubtitle: 'Togo pazarı için premium müşteri deneyimi. GMT saat dilimi, %80 daha ucuz.',
    },
    sv: {
      title: 'Callcenter Togo | Fransktalande Kundtjänst | Call IT Dev',
      description: 'Callcenter för Togo: fransktalande agenter, GMT-tidszon, CSAT 95%, från 3 $/h. 80% besparing.',
      heroTitle: 'Callcenter för Togo — Fransktalande Support från Casablanca',
      heroSubtitle: 'Premium kundtjänst för den togolesiska marknaden. GMT-tidszon, 80% billigare.',
    },
    da: {
      title: 'Callcenter Togo | Fransktalende Kundeservice | Call IT Dev',
      description: 'Callcenter til Togo: fransktalende agenter, GMT-tidszone, CSAT 95%, fra 3 $/t. 80% besparelse.',
      heroTitle: 'Callcenter til Togo — Fransktalende Support fra Casablanca',
      heroSubtitle: 'Premium kundeservice for det togolesiske marked. GMT-tidszone, 80% billigere.',
    },
    zh: {
      title: '多哥呼叫中心 | 法语客服外包 | Call IT Dev',
      description: '多哥呼叫中心外包：法语母语座席，GMT时区，CSAT 95%，3美元/小时起。节省80%。',
      heroTitle: '多哥呼叫中心 — 卡萨布兰卡法语支持',
      heroSubtitle: '以超低价格提供多哥市场优质法语客户服务。GMT时区，节省80%。',
    },
    ja: {
      title: 'トーゴコールセンター | フランス語カスタマーサポート | Call IT Dev',
      description: 'トーゴ向けコールセンター：フランス語ネイティブ、GMT時間帯、CSAT 95%、3$/時間〜。80%コスト削減。',
      heroTitle: 'トーゴ向けコールセンター — カサブランカからのフランス語サポート',
      heroSubtitle: 'トーゴ市場向けプレミアムフランス語顧客サービス。GMT時間帯、80%低コスト。',
    },
    ko: {
      title: '토고 콜센터 | 프랑스어 고객 서비스 | Call IT Dev',
      description: '토고 콜센터 아웃소싱: 프랑스어 원어민, GMT 시간대, CSAT 95%, 시간당 3달러부터. 80% 절감.',
      heroTitle: '토고 콜센터 — 카사블랑카에서 프랑스어 지원',
      heroSubtitle: '토고 시장을 위한 프리미엄 프랑스어 고객 서비스. GMT 시간대, 80% 저렴.',
    },
    ru: {
      title: 'Колл-центр Того | Франкоязычное обслуживание | Call IT Dev',
      description: 'Колл-центр для Того: франкоговорящие агенты, часовой пояс GMT, CSAT 95%, от 3 $/ч. Экономия 80%.',
      heroTitle: 'Колл-центр для Того — Франкоязычная поддержка из Касабланки',
      heroSubtitle: 'Премиум-обслуживание для тоголезского рынка. Часовой пояс GMT, на 80% дешевле.',
    },
  },

  // Gap-fill: Estonia missing languages
  estonia: {
    zh: {
      title: '爱沙尼亚呼叫中心 | 客服外包 | Call IT Dev',
      description: '爱沙尼亚呼叫中心外包：多语言座席，EET时区，CSAT 95%，10€/小时起。e-Estonia数字专长。',
      heroTitle: '爱沙尼亚呼叫中心 — 卡萨布兰卡多语言支持',
      heroSubtitle: '以nearshore价格提供爱沙尼亚市场优质客户服务。EET时区。',
    },
    ja: {
      title: 'エストニアコールセンター | カスタマーサポート外注 | Call IT Dev',
      description: 'エストニア向けコールセンター：多言語対応、EET時間帯、CSAT 95%、10€/時間〜。e-Estonia専門知識。',
      heroTitle: 'エストニア向けコールセンター — カサブランカからの多言語サポート',
      heroSubtitle: 'ニアショア価格でエストニア市場向けプレミアム顧客サービス。EET時間帯。',
    },
    ko: {
      title: '에스토니아 콜센터 | 고객 서비스 아웃소싱 | Call IT Dev',
      description: '에스토니아 콜센터: 다국어 상담원, EET 시간대, CSAT 95%, 10€/시간부터. e-Estonia 전문성.',
      heroTitle: '에스토니아 콜센터 — 카사블랑카에서 다국어 지원',
      heroSubtitle: '니어쇼어 가격으로 에스토니아 시장 프리미엄 고객 서비스. EET 시간대.',
    },
    sv: {
      title: 'Callcenter Estland | Kundtjänst Outsourcing | Call IT Dev',
      description: 'Callcenter för Estland: flerspråkiga agenter, EET-tidszon, CSAT 95%, från 10 €/h. e-Estonia expertis.',
      heroTitle: 'Callcenter för Estland — Flerspråkigt Stöd från Casablanca',
      heroSubtitle: 'Premium kundtjänst för den estniska marknaden till nearshore-priser. EET-tidszon.',
    },
    da: {
      title: 'Callcenter Estland | Kundeservice Outsourcing | Call IT Dev',
      description: 'Callcenter til Estland: flersprogede agenter, EET-tidszone, CSAT 95%, fra 10 €/t. e-Estonia ekspertise.',
      heroTitle: 'Callcenter til Estland — Flersproget Support fra Casablanca',
      heroSubtitle: 'Premium kundeservice for det estiske marked til nearshore-priser. EET-tidszone.',
    },
  },

  // Gap-fill: Paraguay missing languages
  paraguay: {
    zh: {
      title: '巴拉圭呼叫中心 | 西班牙语客服外包 | Call IT Dev',
      description: '巴拉圭呼叫中心外包：西班牙语母语座席，GMT-4时区，CSAT 95%，3美元/小时起。节省75%。',
      heroTitle: '巴拉圭呼叫中心 — 卡萨布兰卡西班牙语支持',
      heroSubtitle: '以超低价格提供巴拉圭市场优质西班牙语客户服务。节省75%。',
    },
    ja: {
      title: 'パラグアイコールセンター | スペイン語カスタマーサポート | Call IT Dev',
      description: 'パラグアイ向けコールセンター：スペイン語ネイティブ、GMT-4時間帯、CSAT 95%、3$/時間〜。75%コスト削減。',
      heroTitle: 'パラグアイ向けコールセンター — カサブランカからのスペイン語サポート',
      heroSubtitle: 'パラグアイ市場向けプレミアムスペイン語顧客サービス。75%低コスト。',
    },
    ko: {
      title: '파라과이 콜센터 | 스페인어 고객 서비스 | Call IT Dev',
      description: '파라과이 콜센터: 스페인어 원어민, GMT-4 시간대, CSAT 95%, 시간당 3달러부터. 75% 절감.',
      heroTitle: '파라과이 콜센터 — 카사블랑카에서 스페인어 지원',
      heroSubtitle: '파라과이 시장을 위한 프리미엄 스페인어 고객 서비스. 75% 저렴.',
    },
    sv: {
      title: 'Callcenter Paraguay | Spansktalande Kundtjänst | Call IT Dev',
      description: 'Callcenter för Paraguay: spansktalande agenter, GMT-4 tidszon, CSAT 95%, från 3 $/h. 75% besparing.',
      heroTitle: 'Callcenter för Paraguay — Spansktalande Support från Casablanca',
      heroSubtitle: 'Premium kundtjänst för den paraguayanska marknaden. 75% billigare.',
    },
    da: {
      title: 'Callcenter Paraguay | Spansktalende Kundeservice | Call IT Dev',
      description: 'Callcenter til Paraguay: spansktalende agenter, GMT-4 tidszone, CSAT 95%, fra 3 $/t. 75% besparelse.',
      heroTitle: 'Callcenter til Paraguay — Spansktalende Support fra Casablanca',
      heroSubtitle: 'Premium kundeservice for det paraguayanske marked. 75% billigere.',
    },
  },

};
